import { render, staticRenderFns } from "./CanteenReportLegacy.vue?vue&type=template&id=6bd28a08"
import script from "./CanteenReportLegacy.vue?vue&type=script&lang=js"
export * from "./CanteenReportLegacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports